import { api } from 'utility';
import {
  getCardServiceUrl,
  getShebaServiceUrl,
  getCreditUrl,
  getEditOrDeleteCardUrl,
  getEditOrDeleteShebaUrl,
  SetDefaultFromShebaListUrl,
  getDefaultCardUrl,
  getContactList,
  getContactListEdit
} from 'URLs';
// Cards
export function getCards(params) {
  return api.get(getCardServiceUrl(), { params }).then((res) => res.data);
}

export function addContact(data) {
  return api.post(getContactList(), data).then((res) => res.data);
}
export function putContact(id, body) {
  return api.put(getContactListEdit(id), body).then((res) => res.data);
}
export function getContact(params) {
  return api.get(getContactList(), { params }).then((res) => res.data);
}
export function deleteContact(id) {
  return api.delete(getContactListEdit(id)).then((res) => res.data);
}
export function postCard(data) {
  return api.post(getCardServiceUrl(), data).then((res) => res.data);
}

export function deleteCard(id) {
  return api.delete(getEditOrDeleteCardUrl(id)).then((res) => res.data);
}

export function putCard(id, body) {
  return api.put(getEditOrDeleteCardUrl(id), body).then((res) => res.data);
}
export function postDefaultCard(id) {
  return api.post(getDefaultCardUrl(id)).then((res) => res.data);
}

// Sheba
export function getShebas(params) {
  return api.get(getShebaServiceUrl(), { params }).then((res) => res.data);
}

export function postSheba(data) {
  return api.post(getShebaServiceUrl(), data).then((res) => res.data);
}

export function deleteSheba(id) {
  return api.delete(getEditOrDeleteShebaUrl(id)).then((res) => res.data);
}

export function putSheba(id, body) {
  return api.put(getEditOrDeleteShebaUrl(id), body).then((res) => res.data);
}

export function postDefaultSheba(id) {
  return api.post(SetDefaultFromShebaListUrl(id)).then((res) => res.data);
}

// PODShebas
export function getPODShebas(params) {
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}

export default {
  getCards,
  postCard,
  deleteCard,
  putCard,
  postDefaultCard,
  deleteContact,
  getShebas,
  postSheba,
  deleteSheba,
  putSheba,
  postDefaultSheba,
  addContact,
  putContact,
  getPODShebas,
  getContact,
};
